import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Avatar, IconButton, Menu, MenuItem } from '@mui/material';
import { Bug, ListCheck } from 'react-bootstrap-icons';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const copy = {
  de: ['Fehler melden', 'Meine Bugmeldungen', 'Benutzerkonto', 'Abmelden'],
  en: ['Report a bug', 'My bug reports', 'Account', 'Sign out'],
  fr: ['Signaler un bug', 'Mes signalements', 'Compte', 'Se déconnecter'],
  it: ['Segnala un bug', 'Le mie segnalazioni', 'Account', 'Esci'],
};

function useCopy() {
  const { i18n } = useTranslation();
  return copy[(i18n?.resolvedLanguage || i18n?.language || 'de').slice(0, 2)] || copy.de;
}

// Shared by the ERP/PMI account menu and the customer's compact account menu.
// The existing authenticated inbox and its server-side owner scope stay in use.
export function BugReportAccountMenuItems({ onSelected, autoFocus = false }) {
  const navigate = useNavigate();
  const location = useLocation();
  const labels = useCopy();
  const visit = (openReport) => {
    onSelected();
    navigate('/admin/bug-reports', {
      state: openReport ? { openBugReport: true, bugReportPagePath: location.pathname } : null,
    });
  };
  return (
    <>
      <MenuItem autoFocus={autoFocus} onClick={() => visit(true)} sx={{ gap: 1, fontSize: '0.82rem' }}>
        <Bug size={14} aria-hidden="true" />{labels[0]}
      </MenuItem>
      <MenuItem onClick={() => visit(false)} sx={{ gap: 1, fontSize: '0.82rem' }}>
        <ListCheck size={14} aria-hidden="true" />{labels[1]}
      </MenuItem>
    </>
  );
}

BugReportAccountMenuItems.propTypes = { onSelected: PropTypes.func.isRequired, autoFocus: PropTypes.bool };

export default function CustomerBugReportAccountMenu({ user, onLogout }) {
  const [anchor, setAnchor] = useState(null);
  const labels = useCopy();
  const close = () => setAnchor(null);
  return (
    <>
      <IconButton aria-label={labels[2]} aria-haspopup="menu" aria-expanded={Boolean(anchor)}
        onClick={(event) => setAnchor(event.currentTarget)}>
        <Avatar sx={{ width: 32, height: 32, bgcolor: '#32cd32' }}>
          {(user?.name || user?.email || 'U').slice(0, 1).toUpperCase()}
        </Avatar>
      </IconButton>
      <Menu anchorEl={anchor} open={Boolean(anchor)} onClose={close} disableScrollLock>
        <BugReportAccountMenuItems onSelected={close} />
        <MenuItem onClick={() => { close(); onLogout(); }}>{labels[3]}</MenuItem>
      </Menu>
    </>
  );
}

CustomerBugReportAccountMenu.propTypes = { user: PropTypes.object, onLogout: PropTypes.func.isRequired };
